import React from 'react';

function IndexLvTds({ outArr, title, inputType = 'text', onChange, isType = false, uneditableCond = (outerIdx, innerIdx) => false }) {
    const defalutValue = inputType === 'number' ? 0 : ''
    const onlyEng = e => {
        e.target.value = e.target.value.replaceAll(/[0-9]|[^\!-z]/gi, "");
    };
    if (inputType == 'checkbox') {
        console.log(outArr);
        return (
            <React.Fragment>
                {
                    outArr.map((innArr, index) => (innArr.map((_, idx) => (<td className='indexTd' key={`${title}_${index}_${idx}`}>
                        <input type={"checkbox"} checked={outArr[index][idx]} value={!outArr[index][idx]} onChange={e => {
                            if (isType) onlyEng(e);
                            onChange(e, title, index, idx);
                        }} style={isType ? { textTransform: 'uppercase' } : {}} disabled={uneditableCond(index, idx)} />
                    </td>))))
                }
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                {
                    outArr.map((innArr, index) => (innArr.map((_, idx) => {
                        if (uneditableCond(index, idx)) {
                            return (
                                <td className='indexTd uneditable' key={`${title}_${index}_${idx}`}>
                                    <p>
                                        {outArr[index][idx] ?? defalutValue}
                                    </p>
                                </td>
                            );
                        } else {
                            return (
                                <td className='indexTd' key={`${title}_${index}_${idx}`}>
                                    <input type={inputType} value={outArr[index][idx] ?? defalutValue} onChange={e => {
                                        if (isType) onlyEng(e);
                                        onChange(e, title, index, idx);
                                    }} style={isType ? { textTransform: 'uppercase' } : {}} />
                                </td>
                            );
                        }
                    })))
                }
            </React.Fragment>
        );
    }
}

export default IndexLvTds;